module.exports = __webpack_public_path__ + "img/wenhua (3).289a6737.png";